import { throttle } from 'lodash';
import { USE_API_MOCKS } from '../env';
import {
  ClinicalTrialDetailType,
  ClinicalTrialRequestType,
  ClinicalTrialType,
  ClinicalTrialUpdateType,
} from '@dynamika-shared/types/clinicalTrials';
import {
  PaginatedArgs,
  PaginatedResponse,
} from '@dynamika-shared/types/general';
import { RESTClientMock, RESTClient } from './client';
import {
  fetchClinicalTrialMock,
  fetchClinicalTrialsListMock,
  updateClinicalTrialMock,
} from './mocks/clinicalTrials';
import { API_URL } from './apiDictionary';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export type ClinicalTrialRequestArgs = PaginatedArgs & {
  filter?: string;
};

export const fetchClinicalTrialsList = throttle(
  async (args?: ClinicalTrialRequestArgs) => {
    if (USE_API_MOCKS) {
      fetchClinicalTrialsListMock(args);
    }

    const { page: rawPage, ...otherArgs } = args ?? {};

    return api.get<PaginatedResponse<ClinicalTrialType>>(
      API_URL.clinicalTrial,
      {
        params: {
          page: rawPage ? rawPage - 1 : 0,
          size: args?.size ?? 10,
          sort: args?.sort,
          ...otherArgs,
        },
        id: 'clinical-trials',
      }
    );
  },
  500
);

export const createClinicalTrial = async (body: ClinicalTrialRequestType) => {
  return api.post<ClinicalTrialType>(API_URL.clinicalTrial, body);
};

export const updateClinicalTrial = async (
  id: string,
  body: ClinicalTrialUpdateType
) => {
  if (USE_API_MOCKS) {
    updateClinicalTrialMock();
  }
  return api.put<ClinicalTrialUpdateType>(
    API_URL.clinicalTrialId.replace(':id', id),
    body
  );
};

export const activateClinicalTrial = async (id: string) => {
  return api.put(API_URL.clinicalTrialActivate.replace(':id', id));
};

export const fetchClinicalTrialById = async (id: string) => {
  if (USE_API_MOCKS) {
    fetchClinicalTrialMock(id);
  }
  return api.get<ClinicalTrialDetailType>(
    API_URL.clinicalTrialId.replace(':id', id),
    {
      id: 'fetchClinicalTrialById',
    }
  );
};

export const fetchClinicalTrialByIdReset = () => {
  api.storage.remove('fetchClinicalTrialById');
};
